var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniarrowwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.5C0 4.94772 0.447715 4.5 1 4.5H12C12.5523 4.5 13 4.94772 13 5.5C13 6.05228 12.5523 6.5 12 6.5H1C0.447715 6.5 0 6.05228 0 5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79289 0.292893C7.18342 -0.0976311 7.81658 -0.0976311 8.20711 0.292893L12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711L8.20711 10.7071C7.81658 11.0976 7.18342 11.0976 6.79289 10.7071C6.40237 10.3166 6.40237 9.68342 6.79289 9.29289L10.5858 5.5L6.79289 1.70711C6.40237 1.31658 6.40237 0.683417 6.79289 0.292893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniarrowwhite);
export default __webpack_public_path__ + "static/media/miniarrowwhite.0eddd5467d288a3a13175bfb2adbf00f.svg";
export { ForwardRef as ReactComponent };